import { useEffect, useRef } from "react"
import { getCSS } from "../../../../_metronic/assets/ts/_utils"
import { FC } from 'react';
type Props = {
    className: string;
    selectedFilter: string;
    onFilterClick: (filter: string) => void;
};

const ChartsWidget2: FC<Props> = ({ className, selectedFilter, onFilterClick }) => {

    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0 p25'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>Company Stats</span>
                    <span className='text-muted fw-bold fs-7'>Analytics are given below</span>
                </h3>

                {/* begin::Toolbar */}
                <div className='card-toolbar' data-kt-buttons='true'>
                    <a
                        className={`btn btn-sm btn-color-muted btn-active btn-active-primary ${selectedFilter === 'all' ? 'active' : ''} px-4 me-1`}
                        id='kt_charts_widget_2_year_btn'
                        onClick={() => onFilterClick('all')}
                    >
                        All
                    </a>
                    <a
                        className={`btn btn-sm btn-color-muted btn-active btn-active-primary ${selectedFilter === 'last7days' ? 'active' : ''} px-4 me-1`}
                        id='kt_charts_widget_2_year_btn'
                        onClick={() => onFilterClick('last7days')}

                    >
                        Last 7 Days
                    </a>

                    <a
                        className={`btn btn-sm btn-color-muted btn-active btn-active-primary ${selectedFilter === 'last30days' ? 'active' : ''} px-4 me-1`}
                        id='kt_charts_widget_2_month_btn'
                        onClick={() => onFilterClick('last30days')}

                    >
                        Last Month
                    </a>

                    <a
                        className={`btn btn-sm btn-color-muted btn-active btn-active-primary ${selectedFilter === 'lastYear' ? 'active' : ''} px-4`}
                        id='kt_charts_widget_2_week_btn'
                        onClick={() => onFilterClick('lastYear')}

                    >
                        Last Year
                    </a>
                </div>
                {/* end::Toolbar */}
            </div>
        </div>
    )
}

export { ChartsWidget2 }